














import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import TransactionStatusView from '@/modules/transaction/components/shared/TransactionStatusView.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import {
  TransactionCollectionType,
  TransactionCollectionWithModel
} from '@/modules/transaction/models/transaction-collection'
import TransactionGateWayView from '@/modules/transaction/components/shared/TransactionGateWayView.vue'
import AdminTransactionActions from '@/modules/transaction/components/admin/table/AdminTransactionActions.vue'

@Component({
  components: {
    CopyableText,
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminTransactionTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  transactions!: TransactionCollectionType

  get fixedData(): TransactionCollectionWithModel {
    return {
      gateways: this.transactions.gateways,
      statuses: this.transactions.statuses,
      transactional_types: this.transactions.transactional_types
    }
  }

  columnComponents = {
    description: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.description })
    },
    status: {
      component: TransactionStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    amount: {
      component: PriceView,
      handler: (value) => ({ price: value, noCurrency: true })
    },
    from_wallet: {
      component: PriceView,
      handler: (value) => ({ price: value, noCurrency: true })
    },
    ref_id: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.ref_id })
    },
    paid_at: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    gateway: {
      component: TransactionGateWayView,
      handler: (value, row, withData) => ({ gateway: row.gateway, gateways: withData.gateways })
    },
    card_number: {
      component: CopyableText,
      handler: (value, row, withData) => ({ copyableText: row.card_number, showText: row.card_number })
    },
    user: {
      component: AdminUserInfoButton,
      handler: (value, row, withData) => ({ basicUser: row.user })
    },
    actions: {
      component: AdminTransactionActions,
      handler: (value, row, withData) => ({ transaction: row, withData: withData })
    }
  }

}
